export const baseURL = "http://64.227.158.97:5000/";
export const secretKey = "5TIvw5cpc0 ";
export const projectName = "Mooncam";
